// extracted by mini-css-extract-plugin
export default {"Emoji":"bbf_a bhf_i bhf_q bhf_j"};